import React, { useEffect, useRef, useState } from "react";

// Adjust the path as necessary

import { EventCard } from "@/components/feature/deadline_guardian/verification_view/EventCard";
import { courtDataUpdatedMock } from "@/views/home/deadline_guardian/mocks/courtEventsMockData";
import { CourtDataItem } from "@/views/home/deadline_guardian/mocks/courtEventsMockData";
import { CourtCaseTableProps } from "@/views/home/deadline_guardian/types/types";
// Filter the events based on futureDate and missingDay criteria
const filteredEvents: Array<CourtDataItem> = courtDataUpdatedMock.filter(
  event => event.futureDate && !event.missingDay,
);

export const DeadlineReminderListTable: React.FC<CourtCaseTableProps> = ({ events = filteredEvents }) => {
  const [selectedEvents, setSelectedEvents] = useState<boolean[]>(new Array(events.length).fill(false));
  const indeterminateRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (indeterminateRef.current) {
      indeterminateRef.current.indeterminate = selectedEvents.some(Boolean) && !selectedEvents.every(Boolean);
    }
  }, [selectedEvents]);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSelected = event.target.checked;
    setSelectedEvents(new Array(events.length).fill(newSelected));
  };

  const handleSelect = (index: number) => {
    const newSelectedEvents = [...selectedEvents];
    newSelectedEvents[index] = !newSelectedEvents[index];
    setSelectedEvents(newSelectedEvents);
  };

  return (
    <div className="mb-6 mt-6">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Deadline Reminder Date
            </th>
            <th className="flex-grow px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Event Details
            </th>
            <th
              className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
              style={{ width: "250px" }}
            >
              Party
            </th>
            <th
              className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500"
              style={{ marginRight: "24px" }}
            >
              {" "}
              Select all &nbsp;
              <input
                type="checkbox"
                className="form-checkbox"
                checked={selectedEvents.every(Boolean)}
                ref={indeterminateRef}
                onChange={handleSelectAll}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredEvents.map((event, index) => (
            <EventCard
              key={index}
              event={event}
              handleSelect={() => handleSelect(index)}
              isSelected={selectedEvents[index]}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
